"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotoUploadRequest = void 0;
var file_1 = require("../../../library/file");
var PhotoUploadRequest = /** @class */ (function () {
    function PhotoUploadRequest() {
        this.file = new file_1.File();
        this.imageType = '';
    }
    return PhotoUploadRequest;
}());
exports.PhotoUploadRequest = PhotoUploadRequest;
;
//# sourceMappingURL=photoUpload.request.js.map